import React, { Component } from 'react'
import classNames from 'classnames'
import withStyles from '@material-ui/core/styles/withStyles'
import PropTypes from 'prop-types'

//Component Imports
import Button from 'components/CustomButtons/Button.jsx'
import Header from 'components/Header/Header.jsx'
import Footer from 'components/Footer/Footer.jsx'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import HeaderLinks from 'components/Header/HeaderLinks.jsx'
import Parallax from 'components/Parallax/Parallax.jsx'
import landingPageStyle from 'assets/jss/material-kit-react/views/landingPage.jsx'

const dashboardRoutes = []

class ScrollToTopOnMount extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return null
    }
}

const PageShell = ({
    classes,
    title,
    blurb,
    img,
    components,
    cta,
    ...rest
}) => (
    <div>
        <ScrollToTopOnMount />
        <Header
            color="transparent"
            routes={dashboardRoutes}
            brand="Resilient Vitality"
            rightLinks={<HeaderLinks />}
            fixed
            changeColorOnScroll={{
                height: 400,
                color: 'primary'
            }}
            {...rest}
        />

        <Parallax filter image={img}>
            <div className={classes.container}>
                <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                        <h1 className={classes.title}>{title}</h1>
                        <h4>{blurb}</h4>
                    </GridItem>
                </GridContainer>
                {cta !== undefined && (
                    <Button
                        color={cta.color}
                        size="lg"
                        href={cta.href}
                        rel="noopener noreferrer"
                    >
                        <i className="fas fa-play" />
                        {cta.title}
                    </Button>
                )}
            </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)}>
            <div className={classes.container}>{components}</div>
        </div>

        <Footer />
    </div>
)

PageShell.propTypes = {
    classes: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    blurb: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    cta: PropTypes.shape({
        title: PropTypes.string.isRequired,
        href: PropTypes.string.isRequired,
        color: PropTypes.string.isRequired
    }),
    components: PropTypes.arrayOf(PropTypes.node)
}

export default withStyles(landingPageStyle)(PageShell)



// WEBPACK FOOTER //
// ./src/views/PageShell.jsx